import AxiosInstance from './config/Http'
import Config from './config/Constants'

export default {
    filterByDomain: (domain: string) =>
    AxiosInstance.get<any[]>(`${Config.core.units}`,
      {params: {
        "numberPlate.equals": domain
      }}
    ),
    get: (id: string) => AxiosInstance.get<any>(`${Config.core.unitByPlate}/${id}`),

    getId: (id: string) => AxiosInstance.get<any>(`${Config.core.units}/${id}`)
}